import { Response } from 'miragejs';

/**
 * Sets up routes used by chili piper service
 */
export default function () {
  this.post('https://api.chilipiper.com/marketing/envoy', () => {
    return new Response(200, {}, { url: 'http://test.com/schedule' });
  });
}
